import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Apply dark class synchronously before first paint to prevent FOUC
try {
  const stored = localStorage.getItem("boo-theme");
  if (stored) {
    const parsed = JSON.parse(stored) as { state?: { isDark?: boolean } };
    if (parsed?.state?.isDark) {
      document.documentElement.classList.add("dark");
    }
  }
} catch {
  // ignore parse errors
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
